<div class="onsight-form-input-select" *ngIf="myClass !== null" >
  <label>{{ myClass.langBase + label | translatePipe }}</label>
  <mat-form-field appearance="fill">
    <mat-select class="form-control" placeholder="{{ 'commons.forms.select' | translatePipe }}"
                [(ngModel)]="myClass.model[name]" name="{{ name }}" [required]="required">
      <input placeholder="{{ 'commons.filter' | translatePipe }}" class="select-search" (keyup)="onKey($event, 'type')">
      <mat-option *ngIf="!filter" [value]="" [disabled]="true">{{ 'commons.forms.select' | translatePipe }}</mat-option>
      <mat-option *ngIf="filter" [value]="0">{{ 'commons.filters.all' | translatePipe }}</mat-option>
      <mat-option [value]="wst.workScheduleTypeID" *ngFor="let wst of list">{{ wst.type }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
